import React from 'react';
import { pointer } from 'd3-selection';

import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';

import COLORS from '../../../../constants/colors.constants';

const Bar = ({
  id,
  x,
  y,
  xScale,
  yScale,
  width,
  height,
  onClick,
  onHover,
  containerRef,
  hoverData = {},
  fill = COLORS.brand,
}) => {
  const handleClick = () => onClick(x, y);
  const handleHover = e => onHover({ x, y, hoverData }, pointer(e, containerRef?.current));
  const handleItemLeave = () => onHover(null, null);

  return (
    <rect
      id={id}
      className="bar"
      x={xScale(x)}
      y={yScale(y)}
      width={width}
      height={height}
      fill={fill}
      opacity={0.6}
      onClick={handleClick}
      onMouseOver={handleHover}
      onMouseLeave={handleItemLeave}
    />
  )
}

const BarGroup = ({
  groupLabel,
  datasets,
  barScale,
  yScale,
  height,
  width,
  containerRef,
  id = 'bar-group',
  onItemClick = () => {},
  onItemHover = () => {},
}) => {
  const allBarValues = datasets?.flatMap(dataset => dataset.data.map(item => ({
    id: `${id}-${dataset.id}-${groupLabel}-${item.x}`,
    datasetId: dataset.id,
    x: item.x,
    y: item.y,
    label: item.label,
    labelVal: item.labelVal,
    barColor: dataset.barColor,
  })))

  const barValuesForGroup = allBarValues.filter(({ x }) => x === groupLabel);

  return barValuesForGroup?.length && (
    barValuesForGroup.map(bar => (
      <Bar
        key={bar.id}
        id={bar.id}
        containerRef={containerRef}
        x={bar.datasetId}
        y={bar.y}
        xScale={barScale}
        yScale={yScale}
        fill={bar.barColor}
        height={height - yScale(bar.y)}
        width={width}
        onClick={onItemClick}
        onHover={onItemHover}
        hoverData={{
          label: bar.label,
          labelVal: bar.labelVal,
          color: bar.barColor,
        }}
      />
    ))
  )
}

const getAllXValues = (datasets = []) => flatten(datasets.map(({ data }) => data.map(({ x }) => x)))

export const MultiBars = ({
  datasets,
  labelScale,
  groupScale,
  yScale,
  height,
  containerRef,
  stacked = false,
  id = 'bars',
  onItemClick = () => {},
  onItemHover = () => {},
}) => {
  const labels = uniq(getAllXValues(datasets));
  return (
    <g>
      {
        labels?.length && (
          labels.map(label => (
            <g
              key={`bargroup-${id}-${label}`}
              id={id}
              transform={`translate(${groupScale(label)}, 0)`}
            >
              <BarGroup
                id={`bargroup-${id}-${label}`}
                containerRef={containerRef}
                datasets={datasets}
                groupLabel={label}
                height={height}
                width={stacked ? groupScale.bandwidth() : labelScale.bandwidth()}
                barScale={stacked ? groupScale : labelScale}
                yScale={yScale}
                onItemClick={onItemClick}
                onItemHover={onItemHover}
              />
            </g>
          ))
        )
      }
    </g>
  )
}


export default MultiBars;
